import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "react-oidc-context";
import config from "../config";
import '../css/AuthRequired.css';

const AuthRequired = () => {
  const auth = useAuth();

    const signOutRedirect = () => {
        const clientId = config.clientId;
        const logoutUri = config.logoutUri;
        const cognitoDomain = config.cognitoDomain;
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
        auth.removeUser();
    };

  return (
    <motion.div
      className="auth-container"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <p>Please sign in to access your account.</p>

      <div className="button-group">
        <button className="primary-btn" onClick={() => auth.signinRedirect()}>
          Sign In
        </button>
        <button className="secondary-btn" onClick={signOutRedirect}>
          Home
        </button>
      </div>
    </motion.div>
  );
};

export default AuthRequired;
